import { GlobalPropertiesService } from './../../../../../core.module/services/global-properties.service';
import { Subscription } from 'rxjs/Subscription';
import { type } from 'os';
import { settings } from 'cluster';
import { start } from 'repl';
import { range } from 'rxjs/observable/range';
import { error } from 'util';
import { ICssShadow } from './../ICssShadow.interface';
import { ICustomPropConfig } from './../../prop-editors.moudule/custom-prop-config.interface';
import { Observer } from 'rxjs/Observer';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SeTextboxConfig } from './se-textbox-config.class';
import { IScreenElement } from './../screen-element.interface';
import { ScreenElementClass } from './../screen-element.class';
import { Subject } from 'rxjs/Subject';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  Renderer2,
} from '@angular/core';
import * as wf from 'webfontloader';


@Component({
  selector: 'app-se-textbox',
  templateUrl: './se-textbox.component.html',
  styleUrls: ['./se-textbox.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SeTextboxComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {
  public sizeChangeObserver: Observer<{ size: { width: number, height: number } }> = {
    next: (x) => {
      this.updateTextSize();
    },
    error: (err) => {

    },
    complete: () => {

    }
  };

  public elementConfig = new SeTextboxConfig(); // override value of base config;
  public animationFinished$: Subscription;

  @ViewChild('textboxContainer') textboxContainer;
  @ViewChild('textWrapper') textWrapper;

  // element props
  @HostBinding('style.background-color') get getBackgroundColor() { return this.elementConfig.backgroundColor; }

  // text shadows
  @HostBinding('style.text-shadow') get geTextShadows() {
    // build box shadow string with all the shadows
    let shadowStr = '';
    if (this.elementConfig.textShadows.length > 0) {
      this.elementConfig.textShadows.forEach((shadow: ICssShadow) => {
        shadowStr += `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}, `;
      });
      shadowStr = shadowStr.substring(0, shadowStr.length - 2); // remove last commma
    }
    return this.sanitizer.bypassSecurityTrustStyle(shadowStr);
  }

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public renderer: Renderer2,
    public gps: GlobalPropertiesService
  ) {
    super(sanitizer); // initilize base class
    this.elementConfig = new SeTextboxConfig(); // create new config for this element type

    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected
    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }
  }

  ngOnInit() {

    if (this.gps.appGlobal.isDesignerMode) {
      const fontList = [{ fontName: this.elementConfig.fontFamily }];
      this.loadFonts(fontList);
    }

    // set text size after animation finishes
    this.animationFinished$ = this.singleAnimationFinished.subscribe(animation => {
      this.updateTextSize();
    });


  }

  ngAfterViewInit() {
    this.updateTextSize();
    this.onElementReadySubject.next(this);
  }

  ngOnDestroy() {
    if (this.animationFinished$) {
      this.animationFinished$.unsubscribe();
    }
  }

  changeHook(change: SimpleChange) {
    this.updateTextSize();
  }


  loadFonts(fontList) {
    // get fonts ready
    const flatList = fontList.map(item => { return item.fontName; });

    if (flatList && flatList.length) {
      this.downloadFonts(flatList);
    }

  }

  downloadFonts(fontlist) {
    // this will not reload exitsing fonts, feel free to call as many times as needed
    wf.load({
      classes: false,
      google: {
        families: fontlist
      },
      loading: function () {
        // console.log('loading fonts ' + fontlist);
      },

    });
  }

  // do not delete this function, it is called by pe-fontpicker
  update() {
    this.updateTextSize();
  }

  updateTextSize() {
    if (this.textboxContainer && this.textboxContainer.nativeElement) {
      this.autoSizeText(this.textboxContainer.nativeElement, 200);
    }
  }

  getText() {

    if (this.elementConfig.htmlMode) {
      const trustedHtml = this.sanitizer.bypassSecurityTrustHtml(this.elementConfig.html);
      return trustedHtml;

    } else {
      return this.elementConfig.text;
    }
  }

  getCustomProperties() {

    const userAdjustableProps: ICustomPropConfig[] = new Array;

    // not using this since the switch to a rich text editor, which outputs HTML not a string
    // const text: ICustomPropConfig = {
    //   type: 'pe-input-string',
    //   name: 'Text',
    //   propPath: 'elementConfig.text',
    //   defaultValue: 'Enter the text you would like to display in here',
    //   tooltip: 'The text of the object',
    //   showDefaultReset: false,
    //   groupName: null,
    //   settings: {
    //   }
    // };

    const text: ICustomPropConfig = {
      type: 'pe-input-htmleditor',
      name: 'Text',
      propPath: 'elementConfig.html',
      defaultValue: 'Enter the text you would like to display in here',
      tooltip: 'The text of the object',
      showDefaultReset: false,
      groupName: null,
      settings: {
        textPropPath: 'elementConfig.text'
      }
    };


    const font: ICustomPropConfig = {
      type: 'pe-fontpicker',
      name: 'Font',
      propPath: 'elementConfig.fontFamily',
      defaultValue: 'Helvetica',
      tooltip: 'Text font',
      showDefaultReset: false,
      groupName: null,
      settings: {
      }
    };

    const fontColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Font Color',
      propPath: 'elementConfig.fontColor',
      defaultValue: null,
      tooltip: 'The default color of the font (hightlight color overrrides this!)',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    const backgroundColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Background Color',
      propPath: 'elementConfig.backgroundColor',
      defaultValue: null,
      tooltip: 'The default color behind the text (highlight color overrides this!)',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    const textShadows: ICustomPropConfig = {
      type: 'pe-shadoweditor',
      name: 'Text Shadow',
      propPath: 'elementConfig.textShadows',
      defaultValue: new Array<ICssShadow>(),
      tooltip: 'this is a sample tooltip',
      showDefaultReset: true,
      groupName: 'effects',
      settings: {
        hasSpread: false,
        buttonText: 'Add Text Shadow',
        horizontal: {
          type: 'pe-slider',
          name: 'Position X',
          propPath: 'x',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, vertical: {
          type: 'pe-slider',
          name: 'Position Y',
          propPath: 'y',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, blur: {
          type: 'pe-slider',
          name: 'Blur',
          propPath: 'blur',
          defaultValue: 25,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [25],
            step: 1,
            range: {
              min: 0,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, spread: {
          type: 'pe-slider',
          name: 'Spread',
          propPath: 'spread',
          defaultValue: 1,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [1],
            step: 1,
            range: {
              min: -50,
              max: 100
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        },
        colorConfig: {
          type: 'pe-colorpicker',
          name: 'Color',
          propPath: 'color',
          defaultValue: 'rgba(150,150,150,1)',
          tooltip: 'Sets the color of the shadow',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }


        }

      }
    };


    userAdjustableProps.push(text);
    // userAdjustableProps.push(font);
    userAdjustableProps.push(fontColor);
    userAdjustableProps.push(backgroundColor);
    userAdjustableProps.push(textShadows);

    return userAdjustableProps;
  }


  autoSizeText(container, attempts = 200) {
    // this.elementConfig.fontSize = 10; //start at
    //  let lastsize;
    this.changeDetectorRef.detectChanges();

    const increaseToFit = (el) => {
      attempts--;
      this.elementConfig.fontSize += 1;
      this.changeDetectorRef.detectChanges();

      if (el.scrollHeight === 0 && el.offsetHeight === 0) {
        // cannot read values, try again later
        return;
      }

      // this function can crash the app, so we need to limit it
      if (attempts <= 0) {
        return;
      }


      if (el.scrollHeight <= el.offsetHeight) {
        increaseToFit(el);
      } else {
        this.elementConfig.fontSize -= 1;
        this.changeDetectorRef.detectChanges();
      }

    };


    const decreaseToFit = (el) => {
      attempts--;
      this.elementConfig.fontSize -= 1;
      this.changeDetectorRef.detectChanges();

      // this function can crash the app, so we need to limit it
      if (attempts <= 0) {
        return;
      }


      if (el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth) {
        decreaseToFit(el);
      }

    };


    if (container.scrollHeight <= container.offsetHeight) {
      increaseToFit(container);
    }

    // if we overshot, decrease here to fit
    if (container.scrollHeight > container.offsetHeight || container.scrollWidth > container.offsetWidth) {
      attempts = 200;
      decreaseToFit(container);
    }



  }


}




// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-textbox/se-textbox.component.ts